<template>
	<div id="third-party" class="policy-document">
		<h2>第三方共享信息清单</h2>
	
		<div class="policy-content">
			<div class="info-box">
				<div class="info-item">
					<text class="info-label">应用运营方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">应用研发方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">注册地址:</text>
					<text class="info-value">深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="info-item">
					<text class="info-label">联系方式:</text>
					<text class="info-value">dev@ledrift.net</text>
				</div>
			</div>
			<h3>引言</h3>
			<p>为保障"乐漂出行"App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件工具开发包（SDK）。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全评估，并要求其按照法律法规要求处理您的信息。
			</p>
	
			<h3>一、第三方SDK列表</h3>
			<p><strong>1. 高德地图SDK</strong></p>
			<p>第三方公司：高德软件有限公司</p>
			<p>共享目的：提供地图展示、定位、地理编码、轨迹记录服务</p>
			<p>共享信息类型：位置信息、设备信息（如IP地址、Mac地址）</p>
			<p>隐私政策链接：https://lbs.amap.com/home/privacy/</p>
	
			<p><strong>2. 微信开放平台SDK</strong></p>
			<p>第三方公司：深圳市腾讯计算机系统有限公司</p>
			<p>共享目的：支持微信登录、微信支付</p>
			<p>共享信息类型：设备信息、订单支付信息</p>
			<p>隐私政策链接：https://weixin.qq.com/cgibin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</p>
	
			<p><strong>3. 支付宝SDK</strong></p>
			<p>第三方公司：支付宝（中国）网络技术有限公司</p>
			<p>共享目的：提供支付宝支付功能</p>
			<p>共享信息类型：设备信息、订单支付信息</p>
			<p>隐私政策链接：https://render.alipay.com/p/c/k2cx0tg8</p>
	
			<p><strong>4. 个推SDK</strong></p>
			<p>第三方公司：浙江每日互动网络科技股份有限公司</p>
			<p>共享目的：用于向用户推送消息和通知</p>
			<p>共享信息类型：设备标识符（如OAID）、网络状态信息</p>
			<p>隐私政策链接：https://www.getui.com/privacy</p>
	
			<p><strong>5. 友盟+SDK</strong></p>
			<p>第三方公司：友盟同欣（北京）科技有限公司</p>
			<p>共享目的：统计App使用情况，分析数据以优化服务</p>
			<p>共享信息类型：设备信息（如IMEI/Android ID/IDFA）、应用列表（仅Android）、匿名化的使用数据</p>
			<p>隐私政策链接：https://www.umeng.com/page/policy</p>
	
			<h3>二、重要提示</h3>
			<p>此清单必须与App中实际集成的所有第三方SDK完全一致！</p>
			<p>请务必前往各第三方官网查看其最新的隐私政策，并将链接准确填入。</p>
			<p>上表仅为示例，您需要根据实际集成情况完整列出所有SDK。</p>
	
			<p class="highlight-text">生效日期：2025年05月01日</p>
		</div>
	</div>

</template>



<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}

	body {
		background-color: #f5f7fa;
		color: #333;
		line-height: 1.6;
		padding: 20px;
	}

	.policy-document {
		border-radius: 12px;
		padding: 40px;
		margin-bottom: 40px;
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
		background-color: #ffffff; /* 修正背景色为白色，原先是红色 */
	}

	.policy-document h2 {
		color: #2c3e50;
		margin-bottom: 20px;
		text-align: center;
		font-size: 1.8rem;
	}

	.policy-content {
		padding: 20px;
		background: #f9f9f9;
		border-radius: 8px;
	}

	.info-box {
		width: 100%;
		padding: 20px;
		background: #e7f4fc;
		border-radius: 8px;
		margin-bottom: 25px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.info-item {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		line-height: 1.8;
	}

	.info-item:last-child {
		margin-bottom: 0;
	}

	.info-label {
		font-weight: 600;
		min-width: 100px;
		flex-shrink: 0;
		color: #333;
	}

	.info-value {
		flex-grow: 1;
		word-break: break-word;
		color: #666;
	}

	.policy-content h3 {
		color: #3498db;
		margin: 20px 0 10px;
	}

	.policy-content p {
		margin-bottom: 15px;
	}

	.back-button {
		display: inline-block;
		margin-top: 20px;
		background: #7f8c8d;
		color: white;
		padding: 10px 18px;
		border-radius: 6px;
		text-decoration: none;
		transition: background 0.3s ease;
	}

	.back-button:hover {
		background: #636e72;
	}

	.page-footer {
		text-align: center;
		padding: 20px;
		color: #7f8c8d;
		font-size: 0.9rem;
		border-top: 1px solid #ddd;
		margin-top: 20px;
	}

	.company-details {
		margin-top: 30px;
		padding: 20px;
		background: white;
		border-radius: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	.company-details h3 {
		color: #2c3e50;
		margin-bottom: 15px;
		text-align: center;
	}

	.company-details p {
		margin: 10px;
	}

	.highlight-text {
		color: #e74c3c;
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.container {
			grid-template-columns: 1fr;
		}

		h1 {
			font-size: 2rem;
		}

		.policy-document {
			padding: 20px;
		}

		.info-box {
			padding: 15px;
		}

		.info-label {
			min-width: 90px;
			margin-bottom: 5px;
		}

		.info-item {
			flex-direction: column;
			margin-bottom: 15px;
		}
	}
</style>
    